import React from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function CreditTypes() {
  const navigate = useNavigate();
  const types = [{
    id: 1,
    name: '3 hrs. Agency Law'
  }, {
    id: 2,
    name: '3 hrs. Legal Issues'
  }, {
    id: 3,
    name: '3 hrs. Fair Housing'
  }, {
    id: 4,
    name: '3 hrs. Contract Law'
  }, {
    id: 5,
    name: '3 hrs. Comm. Standards'
  }, {
    id: 6,
    name: '3 hrs. Disclosure'
  }, {
    id: 7,
    name: '3 hrs. General'
  }, {
    id: 8,
    name: 'NONE'
  }, {
    id: 9,
    name: 'Req. For Licensees'
  }];
  return <div className="space-y-4" data-id="element-404">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-405">Credit Types</h1>

      <div data-id="element-406">
        <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/credit-types/add')} data-id="element-407">
          <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-408" />
          Add
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-409">
        <div className="overflow-x-auto" data-id="element-410">
          <table className="w-full text-sm text-left" data-id="element-411">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-412">
              <tr data-id="element-413">
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-414">Name</th>
                <th className="px-3 py-3 text-center w-36" data-id="element-415">
                  <div data-id="element-416">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-417">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-418">
              {types.map(type => <tr key={type.id} className="hover:bg-slate-50" data-id="element-419">
                  <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-420">
                    {type.name}
                  </td>
                  <td className="px-3 py-2.5 text-center" data-id="element-421">
                    <div className="flex items-center justify-center gap-2" data-id="element-422">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/credit-types/view/${type.id}`)} data-id="element-423">
                        <Eye className="h-4 w-4" data-id="element-424" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/credit-types/edit/${type.id}`)} data-id="element-425">
                        <Edit className="h-4 w-4" data-id="element-426" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-427">
                        <Trash2 className="h-4 w-4" data-id="element-428" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-xs text-slate-600" data-id="element-429">
        Page 1 of 1, showing 9 records out of 9 total, starting on record 1,
        ending on 9
      </div>
      <div className="text-sm text-blue-600 flex items-center gap-1" data-id="element-430">
        <button className="hover:underline" data-id="element-431">&lt;&lt; previous</button>
        <span className="text-slate-400" data-id="element-432">|</span>
        <span className="text-slate-900 font-medium" data-id="element-433">1</span>
        <span className="text-slate-400" data-id="element-434">|</span>
        <button className="hover:underline" data-id="element-435">next &gt;&gt;</button>
      </div>
    </div>;
}